// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.notebook-home-container {
  display: flex;
  flex-direction: column;
  padding: 20px;
  padding-bottom: 150px; /* Space for Notebar */
  height: 100vh;
  overflow: hidden;
}

/* Header */
.notebook-header {
  margin-bottom: 20px;
}

/* Main Content Layout */
.main-content {
  display: flex;
  gap: 20px;
  flex: 1 1;
  overflow: hidden;
}

/* Widgets Area */
.widgets-area {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
  padding-right: 10px;
  min-height: 0; /* Enables flex-child scrolling */
}

/* Widget Container */
.widget-container {
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;
  width: 100%;
  margin-bottom: 20px;
}

/* Notes Container */
.notes-container {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 0;
}

/* Individual Note */
.note {
  width: 95%;
  max-width: 800px;
  padding: 15px;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #ddd;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  text-align: left;
}

/* Note Header */
.note-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

/* Note Time Style */
.note-time {
  font-size: 0.9rem;
  color: #555;
}

/* LLM Output Style */
.llm-output {
  margin-top: 10px;
  font-style: italic;
  color: #555;
}

/* Suggestions Panel */
.suggestions-panel {
  width: 250px;
  flex-shrink: 0;
  position: sticky;
  top: 20px;
  align-self: flex-start;
}

/* Responsive Design */
@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
    gap: 10px;
  }

  .suggestions-panel {
    width: 100%;
    position: static;
  }

  .note {
    width: 100%;
  }
}

/* Optional Global Layout Tweaks */
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/styles/NotebookHome.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,qBAAqB,EAAE,sBAAsB;EAC7C,aAAa;EACb,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,aAAa,EAAE,iCAAiC;AAClD;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,kCAAkC;AAClC;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["/* Main Container */\n.notebook-home-container {\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  padding-bottom: 150px; /* Space for Notebar */\n  height: 100vh;\n  overflow: hidden;\n}\n\n/* Header */\n.notebook-header {\n  margin-bottom: 20px;\n}\n\n/* Main Content Layout */\n.main-content {\n  display: flex;\n  gap: 20px;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* Widgets Area */\n.widgets-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow-y: auto;\n  padding-right: 10px;\n  min-height: 0; /* Enables flex-child scrolling */\n}\n\n/* Widget Container */\n.widget-container {\n  background-color: #f8f9fa;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  padding: 10px;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n/* Notes Container */\n.notes-container {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 10px 0;\n}\n\n/* Individual Note */\n.note {\n  width: 95%;\n  max-width: 800px;\n  padding: 15px;\n  background-color: #fff;\n  border-radius: 5px;\n  border: 1px solid #ddd;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  text-align: left;\n}\n\n/* Note Header */\n.note-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n/* Note Time Style */\n.note-time {\n  font-size: 0.9rem;\n  color: #555;\n}\n\n/* LLM Output Style */\n.llm-output {\n  margin-top: 10px;\n  font-style: italic;\n  color: #555;\n}\n\n/* Suggestions Panel */\n.suggestions-panel {\n  width: 250px;\n  flex-shrink: 0;\n  position: sticky;\n  top: 20px;\n  align-self: flex-start;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .main-content {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .suggestions-panel {\n    width: 100%;\n    position: static;\n  }\n\n  .note {\n    width: 100%;\n  }\n}\n\n/* Optional Global Layout Tweaks */\nhtml, body {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
